import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/Dialog';
import InfoIcon from '@/icons/info.svg';
import routes from '@/routes';
import { AUTH_MODAL_TYPES, openAuthModal } from '@/store/profile';

import Description from './components/Description';

function AccountClosed({ open, onOpenChange }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	function onClick() {
		dispatch(openAuthModal({ type: AUTH_MODAL_TYPES.LOGIN }));
	}

	function onClickLink() {
		onOpenChange();
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="flex flex-col md:max-h-[calc(100vh-40px)]"
				style={{ maxWidth: 'min(calc(100vw - 40px), 397px)' }}
				onClose={onOpenChange}
				onOpenAutoFocus={event => event.preventDefault()}
			>
				<DialogTop
					className="font-sans text-sm leading-6"
					title={t(`authModal.accountClosed.header`)}
				/>
				<div className="mt-6 flex justify-center">
					<InfoIcon className="mb-2 size-5 text-red" />
				</div>

				<Description className="px-4 text-center md:text-xs">
					<Trans
						i18nKey="authModal.accountClosed.description"
						components={{
							anchor: (
								<Link
									onClick={onClickLink}
									className="font-bold text-red"
									to={routes.contact}
								/>
							)
						}}
					/>
				</Description>
				<DialogFooter className="mt-6 flex justify-center">
					<Button type="button" className="w-full" onClick={onClick}>
						{t('common.close')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default AccountClosed;
